import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetSections(args: Parameters<typeof queries.locations.listSections>[0] = {}) {
  const query = queries.locations.listSections({...args, filters: {status: ['active'] as const, ...args.filters}})
  const [sections, meta] = useQuery(query)

  return {query, meta, sections}
}
